import React, { Component } from "react";
import footer from "../Assets/Img/ART_logo_footer.png";
import srt from "../Assets/Img/SRT.png";
import ssn from "../Assets/Img/SSN.png";
import WhatsApp from "../Assets/Icons/WhatsApp.jpg";
import UATRE from "../Assets/Icons/UATRE.svg";
import OSPRERA from "../Assets/Icons/OSPRERA.svg";
import RENATRE from "../Assets/Icons/RENATRE.svg";
import srtSVG from "../Assets/Img/srt_h.svg";
import ig from "../Assets/Icons/social_instagram_icon.png";
import fb from "../Assets/Icons/social_facebook_icon.png";
import { Link } from "react-router-dom";

import "../Assets/Css/App.css";
import "../Assets/Css/Footer.css";
//
export class Footer extends Component {
  
  render() {
    return (
      <div className="mx-5">
        <div className="d-flex mx-5">
          <h6>LOS SEGUROS SON EMITIDOS POR ART MUTUAL RURAL DE SEGUROS DE RIESGOS DEL TRABAJO 
            RECONQUISTA 630, C.A.B.A. CUIT 30-71621143-2 / Nº DE INSCRIPCIÓN EN SSN: 0932 
            SUPERINTENDECIA DE SEGUROS DE LA NACIÓN 0-800-666-8400 WWW.SSN.GOB.AR / C.A.R.T. 
            Nº 0523 SUPERINTENDENCIA DE RIESGOS DEL TRABAJO 0800-666-6778, WWW.ARGENTINA.GOB.AR/SRT</h6>
          <img src={ssn} width={500}>
          </img>
        </div>

        <div className="d-flex mx-5 text-dark bg-white justify-content-around align-items-center mt-3 py-4">
          <div class="col-md-4 text-center my-4 my-md-0">
              <h6>
                      www.argentina.gob.ar/srt
              </h6>
          </div>
          <div class="col-md-4 text-center my-4 my-md-0">
              <h6>
                  0800-666-6778
              </h6>
          </div>
          <img class="col-md-4" loading="lazy" alt="Logo SRT" height="38" data-uuid="11" src={srtSVG}></img>
        </div> 
       


      </div>
      
    );
  }
}

export default Footer;
